"use client"

import clsx from "clsx"
import { useState } from "react"
import { createPortal } from "react-dom"
import { useStickyHeaderState } from "src/checkout/layout/stickyHeader"
import { npPagePbClassName, npPagePtClassName, npPagePxClassName } from "src/components/np-design/components/constants"
import { useBackwardForwardCacheRestored } from "src/hooks/useBackwardForwardCacheRestored"
import { useEventCallback } from "src/hooks/useEventCallback"
import { useKeydown } from "src/hooks/useKeydown"
import { usePreventBodyScroll } from "src/hooks/usePreventBodyScroll"
import { NpHeaderIconLink } from "./NpHeaderIconLink"
import { NpHeaderTextLinks } from "./NpHeaderTextLinks"

export const NpHeaderMenuButton = () => {
  const [visible, setVisible] = useState(false)
  const stickyHeaderState = useStickyHeaderState()

  const hide = useEventCallback(() => setVisible(false))

  usePreventBodyScroll(visible)
  useKeydown("Escape", hide)
  useBackwardForwardCacheRestored(hide)

  const top = stickyHeaderState.visible ? stickyHeaderState.header?.clientHeight || 0 : 0

  return (
    <>
      <NpHeaderIconLink onClick={() => setVisible(!visible)} iconName={visible ? "close" : "menu"} title="Menü" />

      {visible &&
        createPortal(
          <button
            type="button"
            onClick={hide}
            tabIndex={-1}
            style={{ top }}
            className={clsx(
              "z-modal fixed inset-0 flex flex-col gap-px overflow-y-auto bg-white",
              npPagePxClassName,
              npPagePtClassName,
              npPagePbClassName,
            )}
          >
            <NpHeaderTextLinks />
          </button>,
          document.body,
        )}
    </>
  )
}
